import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "../../Axiosinstance";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Modal,
  TextField, Divider,
  MenuItem, Typography,
} from '@mui/material';
import Header from '../../components/Header'
import { CLOUDINARY_UPLOAD_PRESET, baseURL,timestamp } from '../../common'
import { format } from 'date-fns';
import { toast, ToastContainer } from 'react-toastify';
import { decryptData } from '../../Axiosinstance';

const App = () => {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  // const { id } = useParams();
  const { id: encodedBatchId } = useParams(); // Get encoded batchId
  const id = decryptData(encodedBatchId); // Decode & Decrypt
  const [batchData, setBatchData] = useState(null);
  const [assessmentData, setAssessmentData] = useState(null);
  const [fileUploaded, setFileUploaded] = useState(false);

  const [formData, setFormData] = useState({
    batchId: 0,
    description: '',
    moduleName: '',
    url: ''
  });

  const CLOUDINARY_URL = baseURL;
  const CLOUDINARY_UPLOAD = CLOUDINARY_UPLOAD_PRESET;

  useEffect(() => {
    fetchBatchData();
    fetchAssessmentData();
  }, []);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setFormData({ batchId: '', description: '', moduleName: '', url: '' });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDelete = async (id) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this assessment?");
    if (!isConfirmed) return; // If user cancels, exit function
  
    try {
      console.log(id);
      await axios.delete(`trent_assessments/${id}`); // Call the delete API
      setRows((prevRows) => prevRows.filter((row) => row.id !== id)); // Update the state
      toast.success("Assessment deleted successfully");
    } catch (error) {
      console.error("Error deleting item:", error); // Handle errors
    }
  };
  



  const [editingIndex, setEditingIndex] = useState(null);

  const handleEdit = (index) => {
    const rowToEdit = rows[index];
    setFormData({
      batchId: rowToEdit.batchId,
      description: rowToEdit.description,
      moduleName: rowToEdit.moduleName, // Extract module number
      url: rowToEdit.url,
    });
    setEditingIndex(index);
    setOpen(true);
  };

  const fetchBatchData = async () => {
    try {
      const response = await axios.get(`batch/${id}`);
      setBatchData(response.data);
      console.log(response.data, "newdata");
    } catch (error) {
      console.error("Error fetching students:", error);
    }
  };

  const fetchAssessmentData = async () => {
    try {
      const response = await axios.get(`trent_assessments/${id}`);
      setRows(response.data);
      console.log(response.data, "newdata");
    } catch (error) {
      console.error("Error fetching students:", error);
    }
  };

  const handleSave = async () => {
    console.log("Saving data:", formData);

    if (editingIndex !== null) {
      // Update existing row
      const updatedRow = {
        batchId: id,
        description: formData.description,
        moduleName: formData.moduleName,
        url: formData.url,
      };

      // Call the API to update the existing row
      await axios.put(`trent_assessments/${rows[editingIndex].id}`, updatedRow);
      console.log("Updated row:", updatedRow);
    } else {
      // Add new row
      const newRow = {
        batchId: id,
        description: formData.description,
        moduleName: formData.moduleName,
        url: formData.url,
      };

      await axios.post(`trent_assessments/upload`, newRow);
      console.log("New row added:", newRow);
      setFileUploaded(false);
    }

    fetchAssessmentData(); // Fetch updated assessment data
    handleClose(); // Close the modal after saving
  };

  const handleView = (url) => {
    console.log(url)
    if (url) {
      window.open(url, '_blank');
    } else {
      alert('No file uploaded');
    }
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = async (e) => {

    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const formData = new FormData();
      // Append file and upload details to FormData
      formData.append('file', selectedFile);
      formData.append('upload_preset', CLOUDINARY_UPLOAD);
      formData.append('public_id', `LMS/Trent/${selectedFile.name} +' - '+ ${timestamp}`);

      try {
        const response = await fetch(baseURL, {
          method: 'POST',
          body: formData,
        });

        const data = await response.json();
        if (data.secure_url) {
          const profileUrl = data.secure_url; // Store the URL
          setFormData((prevData) => ({ ...prevData, url: profileUrl })); // Update formData with the profileUrl
          console.log("File uploaded successfully:", profileUrl);
          setFileUploaded(true);
        } else {
          throw new Error('Failed to upload image.');
        }
      } catch (error) {
        console.error("Error uploading file:", error);
        // Optionally, show an error message to the user here
      }
    }
  };

  // const formatCreatedAt = (dateString) => {
  //   const date = new Date(dateString);
  //   return `${date.toLocaleDateString()} ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}`;
  // };

  return (
    <div>
      <Header />
      <br />
      <Box p={6}>
        <TableContainer component={Paper}>
          <Box display="flex" justifyContent="flex-start" gap={2} mb={2}>
            <Link to="/Allcourse">
              <Button variant="contained"  style={{   backgroundColor: '#007bff' ,color:"white"  }}>
                All Courses
              </Button>
            </Link>
            <Button variant="contained"  style={{   backgroundColor: '#007bff' ,color:"white"  }} onClick={handleOpen}>
              Add New Template
            </Button>
          </Box>

          <Table>
            <TableHead>
              <TableRow>
                {/* <TableCell>Batch ID</TableCell> */}
                <TableCell style={{ fontWeight: 'bold'}} >Description</TableCell>
                <TableCell style={{ fontWeight: 'bold'}} >Uploaded Date and Time</TableCell>
                <TableCell style={{ fontWeight: 'bold'}} >Module</TableCell>
                <TableCell style={{ fontWeight: 'bold'}} >Action</TableCell>
              </TableRow> 
            </TableHead>
            <TableBody>
              {rows.length > 0 ? (
                rows
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => (
                    <TableRow key={index}>
                      {/* <TableCell>{row.batchId}</TableCell> */}
                      <TableCell>{row.description}</TableCell>
                      <TableCell>
                        {row.createdAt ? (
                          format(new Date(row.createdAt), 'dd/MM/yyyy HH:mm')
                        ) : (
                          'Invalid date'
                        )}
                      </TableCell>                      <TableCell>{row.moduleName}</TableCell>
                      <TableCell>
                        <Button
                          variant="outlined"
                          color="primary"
                          sx={{ marginRight: 1 }}
                          onClick={() => handleView(row.url)}
                        >
                          View
                        </Button>
                        <Button
                          variant="outlined"
                          color="success"
                          sx={{ marginRight: 1 }}
                          onClick={() => handleEdit(index)}
                        >
                          Edit
                        </Button>
                        <Button
                          variant="outlined"
                          color="error"
                          onClick={() => handleDelete(row.id)}
                        >
                          Delete
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No data available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[5, 10, 15]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>

        <Modal open={open} onClose={handleClose}>
          <Box
            component={Paper}
            p={4}
            sx={{
              width: '90%',
              maxWidth: 600,
              margin: 'auto',
              mt: '10%',
              display: 'flex',
              flexDirection: 'column',
              gap: 3,
              borderRadius: 2,
            }}
          >
            <Typography variant="h6" component="h2" textAlign="center" color="primary" gutterBottom>
              Add New Template
            </Typography>

            {/* <TextField
              label="Batch ID"
              value={formData.batchId}
              onChange={(e) => setFormData({ ...formData, batchId: e.target.value })}
              fullWidth
              variant="outlined"
            /> */}

            <TextField
              select
              label="Module"
              value={formData.moduleName}
              onChange={(e) => {
                console.log("Module Value:", e.target.value);
                setFormData({ ...formData, moduleName: e.target.value });
              }}
              fullWidth
              variant="outlined"
            >
              {batchData?.moduleDetails && batchData?.moduleDetails.length > 0 ? (
                batchData.moduleDetails.map((module) => (
                  <MenuItem key={module.id} value={module.moduleName}>
                    {module.moduleName} {/* Displaying moduleName */}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No modules available</MenuItem>
              )}
            </TextField>
            <TextField
              label="Description"
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              fullWidth
              multiline
              rows={3}
              variant="outlined"
            />
            {/* <TextField
              label="URL"
              value={formData.url}
              onChange={(e) => setFormData({ ...formData, url: e.target.value })}
              fullWidth
              variant="outlined"
            /> */}
            <TextField
              type="file"
              onChange={(event) => {
                const file = event.target.files[0];
                if (file && file.size > 8 * 1024 * 1024) {
                  event.target.value = ""; // Reset file input
                  alert("File size must be less than 8MB.");
                } else {
                  handleFileChange(event);
                }
              }}
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              label={formData.url ? "Reupload File" : "Upload File"}
            />
            <Box display="flex" justifyContent="flex-start" gap={2} mb={2}>
              <Button variant="contained" color="primary" disabled={!fileUploaded} onClick={handleSave}>
                Save
              </Button>
              <Button variant="outlined" color="error" onClick={handleClose}>
                Cancel
              </Button>
            </Box>
          </Box>
        </Modal>
      </Box>
      <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar />

    </div>
  );
};

export default App;
